let exports = {};
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
import { ScrollTrigger } from "gsap/ScrollTrigger";
var isMobile = window.matchMedia('(max-width: 767px)');
var isTabletPortrait = window.matchMedia('(max-width: 1023px)');
//export default {

// sections = document.querySelectorAll('.section');
exports.coverAnimation = (that) => {
    
    // gsap.set(".page-title h1", { autoAlpha: 1 })
    // let split = new SplitText(".page-title h1 span:not(.year)", { type: " words,chars,lines" });
    var tl = gsap.timeline({ repeat: !1, yoyo: true, duration: 0.6 });
    tl
    .fromTo("#year2020 g", {
            autoAlpha: 0,
            rotate: 0,
            skewY: 150
        }, {
            autoAlpha: 0.5,
            rotate: 0,
            skewY: 0,
            ease: "power1.inOut",
            stagger: {
                each: 0.4
            }
        }
    );

        //tl.fromTo(split.chars, { y: 200, rotation: 70, autoAlpha: 0 }, { rotation: 0, autoAlpha: 1, y: 0, ease: "back(4)", duration: 1, stagger: { from: "start", each: 0.05 } }, "+=2.5"),
    tl.fromTo(".page-title h1", { autoAlpha: 0, opacity: 0, y: "80%" }, {autoAlpha: 1, opacity: 1, y: 0, ease:Power1.easeIn, duration: 0.8});
        // tl.fromTo(".page-title h1 span:not(.year)", {y:"100%",autoAlpha: 0, rotate: 150}, {y: 0, duration: 1, autoAlpha: 1, transformOrigin: "left", rotate:0, skewX:0, ease: "power1.inOut"}, "+=2.5"),
    tl.fromTo(".page-title h1 span.year", { y: "90%", autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 }, "+=0.3")
};
exports.setupTimeLines = (that) => {
    var sections = document.querySelectorAll('.section'); // ----------------------
    // LINE ANIMATION - DESKTOP
    // ----------------------

    function createDesktopLines(sectionItem, sectionYear, index) {
        var tl = gsap.timeline();
        var horizontalLine = sectionItem.querySelector('.sectionLinesDesktop__horizontal-line');
        var verticalLineTop = sectionItem.querySelector('.sectionLinesDesktop__vertical-line--top');
        var verticalLineBottom = sectionItem.querySelector('.sectionLinesDesktop__vertical-line--bottom');
        var sectionText = sectionItem.querySelector(".section__content");
        var sectionGraphic = sectionItem.querySelector(".imagesWrapper .image");
        //   var sectionGraphic = sectionItem.querySelector('.section__graphics');
        var marginYear = 20;
        var sectionHeight = parseInt(getComputedStyle(sectionItem).height);
        var sectionYearHeight = parseInt(getComputedStyle(sectionYear).height);
        var verticalLineHeight = (sectionHeight - sectionYearHeight) / 2 - marginYear;
        verticalLineBottom.style.top = verticalLineHeight + marginYear + sectionYearHeight + marginYear + 'px'; // Timeline

        tl.to(verticalLineTop, {
            height: 10,
            duration: 0.05
        });
        tl.call(function() {
            ScrollTrigger.getById(index).direction === 1 ? sectionItem.classList.add('active') : sectionItem.classList.remove('active');

            if (index === 1) {
                if (ScrollTrigger.getById(index).direction === 1) {
                    document.body.classList.add('scrolled');
                } else {
                    document.body.classList.remove('scrolled');
                }
            }
        });
        tl.to(verticalLineTop, {
            height: verticalLineHeight,
            duration: 1
        });
        tl.call(function() {
            ScrollTrigger.getById(index).direction === 1 ? sectionYear.classList.add('active') : sectionYear.classList.remove('active');
        });
        tl.to(verticalLineBottom, {
            height: verticalLineHeight,
            duration: 2,
            delay: 0.5
        });
        tl.to(horizontalLine, {
            width: '100%',
            duration: 1
        });
        tl.fromTo(sectionText, {
            y: "50%",
            autoAlpha: 0
        }, {
            y: 0,
            autoAlpha: 1,
            duration: 2
        }, "-=4.2");
        tl.fromTo(sectionGraphic, {
            y: "50%",
            autoAlpha: 0
        }, {
            y: 0,
            autoAlpha: 1,
            duration: 2
        }, "-=4.2");
        ScrollTrigger.create({
            id: index,
            animation: tl,
            trigger: verticalLineTop,
            start: 'top 60%',
            end: '+=' + sectionItem.getBoundingClientRect().height,
            scrub: true //markers:    true,

        });
    } // ----------------------
    // LINE ANIMATION - MOBILE
    // ----------------------


    function createMobileLines(sectionItem, index) {
        
        var tl = gsap.timeline();
        var sectionYearMobile = sectionItem.querySelector('.sectionYear--mobile');
        var line1 = sectionItem.querySelector('.sectionLines-mobile__line--1');
        var line2 = sectionItem.querySelector('.sectionLines-mobile__line--2');
        var line3 = sectionItem.querySelector('.sectionLines-mobile__line--3');
        var line4 = sectionItem.querySelector('.sectionLines-mobile__line--4');
        var line5 = sectionItem.querySelector('.sectionLines-mobile__line--5');
        var smallVerticalHeight = 50; // check if images loaded

        var imgs = sectionItem.querySelectorAll('.js_lazy-image-mobile');
        var len = imgs.length;
        var counter = 0;
        // imgs.forEach(function(img) {
        //     if (img.complete && img.naturalHeight !== 0) {
        //         incrementCounter();
        //     } else {
        //         img.addEventListener('load', incrementCounter, false);
        //     }
        // });

        // function incrementCounter() {
        //     console.log('mobile image loaded');
        //     counter++;

        //     if (counter === len) {
        //         createScrollAnim();
        //     }
        // }
        createScrollAnim();
        function createScrollAnim() {
            var sectionHeight = parseInt(getComputedStyle(sectionItem).height);
            var sectionYearHeight = parseInt(getComputedStyle(sectionYearMobile).height);
            var line3Height = sectionHeight - smallVerticalHeight - sectionYearHeight - smallVerticalHeight;
            line1.style.top = sectionYearHeight + 'px';
            line2.style.top = sectionYearHeight + smallVerticalHeight + 'px';
            line3.style.top = sectionYearHeight + smallVerticalHeight + 1 + 'px';
            line4.style.top = sectionYearHeight + smallVerticalHeight + line3Height + 'px';
            line5.style.top = sectionYearHeight + smallVerticalHeight + line3Height + 'px'; // Timeline

            tl.to(line1, {
                height: 1 + 'px',
                duration: 0.05
            });
            tl.call(function() {
                ScrollTrigger.getById(index).direction === 1 ? sectionYearMobile.classList.add('active') : sectionYearMobile.classList.remove('active');
            });
            tl.to(line1, {
                height: smallVerticalHeight + 2 + 'px',
                duration: 0.25
            });
            tl.call(function() {
                console.log('call');
                ScrollTrigger.getById(index).direction === 1 ? sectionItem.classList.add('active') : sectionItem.classList.remove('active');

                if (index === 1) {
                    if (ScrollTrigger.getById(index).direction === 1) {
                        document.body.classList.add('scrolled');
                    } else {
                        document.body.classList.remove('scrolled');
                    }
                }
            });
            tl.to(line2, {
                width: '50%',
                duration: 0.5
            });
            tl.to(line3, {
                height: line3Height + 'px',
                duration: 2,

            }, '-=.5');
            tl.to(line4, {
                width: '50%',
                duration: 0.5,
            });
            tl.to(line5, {
                height: smallVerticalHeight + 2 + 'px',
                duration: 0.25
            });
            ScrollTrigger.create({
                id: index,
                animation: tl,
                trigger: line1,
                start: 'top 75%',
                end: '+=' + sectionItem.getBoundingClientRect().height,
                scrub: true //markers:    true,

            });
        }
    }

    sections.forEach(function(sectionItem, index) {
        var sectionYear = sectionItem.querySelector('.sectionYear--desktop');

        if (sectionYear) {
            // -------------------
            // DESKTOP LINES
            // -------------------
            if (!isTabletPortrait.matches) {
                createDesktopLines(sectionItem, sectionYear, index);
            } else {
                createMobileLines(sectionItem, index);
            }
        } else {
            var tl = gsap.timeline();
            var verticalLine = sectionItem.querySelector('.sectionLinesDesktop__vertical-line');
            var horizontalLine = sectionItem.querySelector('.sectionLinesDesktop__horizontal-line');
            tl.to(verticalLine, {
                height: '100%',
                duration: 4
            });

            if (index === 0) {
                tl.to(horizontalLine, {
                    width: '50%',
                    duration: 1
                });
            } else {
                tl.to(horizontalLine, {
                    width: '100%',
                    duration: 1
                });
            }

            ScrollTrigger.create({
                animation: tl,
                trigger: verticalLine,
                start: 'top 50%',
                end: '+=' + sectionItem.getBoundingClientRect().height,
                scrub: true //markers: true,

            });
        }
    });
}

//}

export default exports;